import DataTable from "react-data-table-component";
import { FLIGHT_STATUS, REQUEST_TYPES, ROLES } from "../../../../constants";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../hooks/app";
import { getUser } from "../../../../store/slices/auth-slice";

const RequestTable = ({
  data,
  instructor,
  handlePageChange,
  handlePerRowsChange
}: {
  data: any;
  instructor: boolean;
  handlePageChange: any,
  handlePerRowsChange: any
}) => {

  const navigate = useNavigate()
  const user = useAppSelector(getUser)
  const totalCount = useAppSelector((state) => state.requestSignature.totalCount);

  const BASE_URL = process.env.REACT_APP_API_PROTOCOL + "://" + process.env.REACT_APP_API_HOST
  const columns = [
    {
      name: "Request ID",
      selector: (row: any) => row?._id,
      sortable: true,
      grow: 6,
      wrap: true,
    },
    {
      name: "Request Date",
      selector: (row: any) => moment(row?.createdAt).format("DD MMMM, YYYY"),
      sortable: true,
      grow: 6,
      wrap: true,
    },
    {
      name: instructor ? "Instructor  Name" : "Student Name",
      selector: (row: any) => (instructor ? row?.instructorId?.firstname + " " + row?.instructorId?.lastname : row?.createdBy?.firstname + " " + row?.createdBy?.lastname),
      sortable: true,
      grow: 4,
      wrap: true,
    },
    {
      name: "Request Type",
      selector: (row: any) => row?.requestType,
      sortable: true,
      grow: 3,
      wrap: true,
    },

    {
      name: "Request For",
      selector: (row: any) => row?.requestType === REQUEST_TYPES.ENDORSEMENT ? row?.endorsement?.name : row?.requestType === REQUEST_TYPES.FLIGHT ? row?.flights?.map((f: any) => f.flightNumber).join(", ") : `${row?.ratingType} (${row?.ratingModal})`,
      sortable: true,
      grow: 7,
      wrap: true,
    },
    {
      name: "Signatures",
      selector: (row: any) => { return row?.signature && row.status === FLIGHT_STATUS.APPROVED ? <img src={`${BASE_URL}/uploads/signatures/${row?.signature}`} width={200} /> : null },
      sortable: true,
      grow: 3,
      wrap: true,
    },
    {
      name: "Status",
      cell: (row: any) => {
        if (row.status === FLIGHT_STATUS.APPROVED) {
          return <h4 className="badge p-2 bg-success">Approved</h4>;
        }

        if (row.status === FLIGHT_STATUS.PENDING) {
          return <h4 className="badge p-2 bg-warning">Pending</h4>;
        }

        if (row.status === FLIGHT_STATUS.CANCELLED) {
          return <h4 className="badge p-2 bg-danger">Cancelled</h4>;
        }
      },
    },
  ];
  const paginationComponentOptions = {
    rowsPerPageText: "Rows Per Page",
    rangeSeparatorText: "of",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Requests",
    styles: {
      background: "red",
    },
  };

  return (
    <>
      <DataTable
        columns={columns}
        data={data || []}
        selectableRows
        pagination
        paginationServer
        paginationTotalRows={totalCount}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        onRowClicked={(row) => {
          if (user?.role === ROLES.INSTRUCTOR) {
            navigate(`/training/request-signatures/approve/${row?._id}`)
          }
        }}
        paginationComponentOptions={paginationComponentOptions}
        customStyles={{
          rows: {
            style: {
              minHeight: "60px",
              cursor: user?.role === ROLES.INSTRUCTOR ? "pointer" : "default",
              "&:nth-child(odd)": {
                background: "#EFF6FF",
              },
            },
          },
          headCells: {
            style: {
              fontSize: "14px",
              fontWeight: "bold",
            },
          },
          cells: {
            style: {
              fontSize: "14px",
            },
          },
        }}
      />
    </>
  );
};

export default RequestTable;
